<template>
  <v-chip
    outlined
    class="ma-2"
    v-if="filter.calidad.length !== 0"
    close
    small
    color="warning"
    text-color="primary"
    @click:close="() => clrCalidad()"
  >
    {{ filter.calidad.length !== 0 ? filterconsolidado.length : null }}
  </v-chip>
</template>

<script>
  import { mapState, mapGetters, mapMutations } from "vuex";

  export default {
    methods: {
      ...mapMutations(["CLR_BUSCARCALIDAD", "setMenuDomoDeco"]),
      clrCalidad() {
        this.CLR_BUSCARCALIDAD();
        this.setMenuDomoDeco(false)
      },
    },
    computed: {
      ...mapGetters(["filterconsolidado"]),
      ...mapState(["filter"]),
    },
  };
</script>
